import React, { useEffect, useState } from "react";
import ResumenCalibracion from "../components/ResumenCalibracion";
import { obtenerFechasCalibracion } from "../services/calibracionesService";

function Dashboard() {
  const [instrumentos, setInstrumentos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorCarga, setErrorCarga] = useState("");
  const [reintento, setReintento] = useState(0);

  useEffect(() => {
    let cancelado = false;

    const cargarDashboard = async () => {
      setLoading(true);
      setErrorCarga("");

      try {
        const resultado = await obtenerFechasCalibracion();

        if (!cancelado) {
          setInstrumentos(resultado.instrumentos || []);
        }
      } catch (error) {
        console.error("❌ Error cargando panel de control:", error);

        if (!cancelado) {
          setInstrumentos([]);
          setErrorCarga(
            "No se pudo cargar el panel de control. Verifica tu conexión e inténtalo nuevamente."
          );
        }
      } finally {
        if (!cancelado) {
          setLoading(false);
        }
      }
    };

    cargarDashboard();

    return () => {
      cancelado = true;
    };
  }, [reintento]);

  if (loading) {
    return (
      <div className="mx-auto w-full max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
        <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
          <p className="text-sm text-slate-500">
            Cargando panel de control...
          </p>
        </div>
      </div>
    );
  }

  if (errorCarga) {
    return (
      <div className="mx-auto w-full max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
        <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
          <div className="rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-700">
            {errorCarga}
          </div>

          <button
            onClick={() => setReintento((valor) => valor + 1)}
            className="mt-4 h-10 rounded-lg bg-cyan-600 px-4 text-sm font-semibold text-white transition hover:bg-cyan-700"
          >
            Reintentar
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="mx-auto w-full max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
      <ResumenCalibracion instrumentos={instrumentos} />
    </div>
  );
}

export default Dashboard;